'use client'

import Image from 'next/image'
import classNames from 'classnames'
import styles from './NewsletterSignUpSection.module.scss'
import RichText from '@/components/RichText/RichText'
import NewsletterForm from './NewsletterForm'
import WhatToExpect from './WhatToExpect'
import { headerSerializer, smallHeaderSerializer, subtitleSerializer } from './serializers'
import useBreakpoint from '@/hooks/use-breakpoint'

const NewsletterSignUpSection = ({
  content,
  sectionBackground,
}: NewsletterSignUpSectionProps) => {
  const { eyebrow, header, subtitle, showWhatToExpect, expectationItems, successMessage } = content || {}
  const { isMobile } = useBreakpoint()

  if (!content) {
    return null
  }

  return (
    <section
      className={styles.newsletterSection}
      style={{ backgroundColor: sectionBackground === 'dough' ? 'var(--dough)' : undefined }}
    >
      <div className={classNames(styles.container, {
        [styles.containerWithoutWhatToExpect]: !showWhatToExpect,
      })}
      >
        <div className={classNames(styles.content, {
          [styles.contentWithWhatToExpect]: showWhatToExpect,
          [styles.contentWithoutWhatToExpect]: !showWhatToExpect,
        })}
        >
          {eyebrow && <div className={styles.eyebrow}>{eyebrow}</div>}

          {header && header.length > 0 && (
            <RichText value={header} components={showWhatToExpect ? smallHeaderSerializer : headerSerializer} />
          )}

          {subtitle && (
            <RichText value={subtitle} components={subtitleSerializer} />
          )}
        </div>

        {showWhatToExpect && <WhatToExpect expectationItems={expectationItems} />}

        <div className={classNames({
          [styles.formWithWhatToExpect]: showWhatToExpect,
          [styles.formWithoutWhatToExpect]: !showWhatToExpect,
        })}
        >
          <NewsletterForm successMessage={successMessage} hasWhatToExpect={showWhatToExpect} />
        </div>

        {/* Bao Bao Image */}
        <div className={classNames(styles.baoBaoImageSection, {
          [styles.baoBaoImageWithWhatToExpect]: showWhatToExpect,
          [styles.baoBaoImageWithoutWhatToExpect]: !showWhatToExpect,
        })}
        >
          <div className={styles.baoBaoImageWrapper}>
            <Image
              src={isMobile ? '/images/baobao-with-wte.png' : showWhatToExpect ? '/images/baobao-with-wte.png' : '/images/baobao-without-wte.png'}
              alt="Bao Bao"
              width={isMobile ? 184 : showWhatToExpect ? 360 : 437}
              height={isMobile ? 173 : showWhatToExpect ? 340 : 411}
              priority
            />
          </div>
        </div>
      </div>
    </section>
  )
}

NewsletterSignUpSection.displayName = 'NewsletterSignUpSection'

export default NewsletterSignUpSection
